<div class="page-container">
  <section>
    <div class="title-container">
      <h1 class="title">{{'MAIN.LEXICON' | translate}}</h1>

      <div class="control">
        <div class="form-control">
          <ng-select
            [dropdownPosition]="'auto'"
            [items]="categoryList"
            [searchable]="false"
            [placeholder]="'Select category'"
            (change)="selectCategory($event?.id)"
            [formControl]="selectCategoryControl"
            appendTo="body"
            class="white"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center pl-4">
                <img *ngIf="!!item?.icon" [src]="item?.icon" alt="">
                {{item.label | translate}}
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-index="index">
              <img *ngIf="!!item?.icon" [src]="item?.icon" alt="">
              {{item.label | translate}}
              <img class="selected" height="24" width="24" src="assets/img/check.svg" [alt]="''">
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="lexicon-nav-list">
        <ul class="lexicon-list">
          <li class="lexicon-list-item all"
              [class.active]="!selectedFilter"
              (click)="clearFilter()"
          >
            All
          </li>
          <ng-container *ngFor="let item of (lexiconListNav$ | async)">
            <li *ngIf="item?.title?.length === 1"
                class="lexicon-list-item"
                [class.active]="selectedFilter === item?.title"
                (click)="selectFilter(item?.title)"
            >
              {{ item?.title || 'A' }}
            </li>
          </ng-container>
        </ul>
      </div>

      <div class="lexicon-content-list-container">
        <div class="lexicon-content-list">
          <ng-container *ngFor="let item of (lexiconList$ | async); let index = index">
            <div *ngIf="item?.data && item?.data?.length"
                 class="lexicon-content-list-item"
                 [class.open]="item?.isOpen">

              <div class="lexicon-content-list-item-head" (click)="openPanel(index)">
                <h4 class="title">
                  {{ item?.title }}
                </h4>

                <img class="icon ml-auto" src="assets/img/chevron-up-main.svg" height="24" width="24">
              </div>

              <ul class="posts-list">
                <li *ngFor="let lexicon of item?.data" class="post-item">
                  <a [routerLink]="lexicon?.lexicon_url" class="link">
                    {{ lexicon?.title }}
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
</div>
